import { map as rxjsmap } from 'rxjs';

import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Instrument, InstrumentType, ModelType } from 'src/app/kuba/measure-protocol/models/instrument';
import { CMP, MP, CMPInstrument } from 'src/app/kuba/measure-protocol/models/measure-protocol';
import {
    CMPComment,
    EarthLeakage,
    PowerLeakage,
    Temperature,
    TemperatureModel,
    TemperatureType,
} from 'src/app/kuba/measure-protocol/models/mpc-details';
import { environment } from 'src/environments/environment';

import { VisualControl } from '../models/visual-control.model';
import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MeasureProtocolService {

    constructor(private http: HttpClient) {
    }

    getClientContactUser(clientId: number) {
        return this.http
            .get(
                environment.BASE_URL +
                    '/clientcontact/clientcontactsuser/' +
                    clientId,

            ).pipe(rxjsmap(result => result));
    }

    getAllMeasureProtocol(featureId:number, featureKey: number, key: string) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${featureKey}/measureProtocol/byfeature/${featureId}`,

            ).pipe(rxjsmap((result:any) => result));
    }

    getAllCompleteMeasureProtocol(id: number, key: string) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${id}/measureProtocol/all/measureProtocolComplete`,

            ).pipe(rxjsmap(result => result));
    }

    create(kundeELId: number, newMP: MP) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/kundeEL/' +
                    kundeELId +
                    '/measureProtocol',
                newMP,

            ).pipe(rxjsmap(result => result));
    }

    update(kundeELId: number, ExistingMP: MP) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/kundeEL/' +
                    kundeELId +
                    '/measureProtocol',
                ExistingMP,

            ).pipe(rxjsmap(result => result));
    }

    deleteMP(id: number, kundeELId: number) {
        return this.http
            .delete(
                environment.BASE_URL +
                    '/kundeEL/' +
                    kundeELId +
                    '/measureProtocol/delete/' +
                    id,
            ).pipe(rxjsmap(result => result));
    }

    createCMP(MeasureProtocolId: number, newMP: CMP) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocol/' +
                    MeasureProtocolId +
                    '/measureProtocolComplete',
                newMP,

            ).pipe(rxjsmap(result => result));
    }

    updateCMP(kundeELId: number, ExistingCMP: CMP) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocol/' +
                    kundeELId +
                    '/measureProtocolComplete',
                ExistingCMP,

            ).pipe(rxjsmap(result => result));
    }

    deleteCMP(id: number, kundeELId: number) {
        return this.http
            .delete(
                environment.BASE_URL +
                    '/measureProtocol/' +
                    kundeELId +
                    '/measureProtocolComplete/delete/' +
                    id,
            ).pipe(rxjsmap(result => result));
    }

    getMeasureProtocolById(id: number, kundeELId: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/kundeEL/' +
                    kundeELId +
                    '/measureProtocol/' +
                    id,
            ).pipe(rxjsmap(res => res));
    }

    getAllInstruments(id: number) {
        return this.http
            .get(
                `${environment.BASE_URL}/instrument/measureProtocol/` + id,

            ).pipe(rxjsmap(result => result));
    }

    getAllCMPInstruments(id: number) {
        return this.http
            .get(
                `${environment.BASE_URL}/instrument/measureProtocolComplete/` +
                    id,

            ).pipe(rxjsmap(result => result));
    }

    getInstrumentById(cmpId: number, id: number) {
        let result: any;
        return this.http
            .get(environment.BASE_URL + '/instrument/' + id, ).pipe(rxjsmap(res => res));
    }

    getMeasureProtocolCompleteById(id: number, kundeELId: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocol/' +
                    kundeELId +
                    '/measureProtocolComplete/' +
                    id,
            ).pipe(rxjsmap(res => res));
    }

    //  bind instrument type
    getAllByType(kundeELId: number, key: string) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/type`,
            ).pipe(rxjsmap((result: any) => result));
    }

    //update Instrument Type
    updateInsType(
        existingCategory: InstrumentType,
        key: string,
        kundeELId: number
    ) {
        return this.http
            .put(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/type`,
                existingCategory,

            ).pipe(rxjsmap(result => result));
    }

    //adding Instrument Type
    createInsType(newCategory: InstrumentType, key: string, kundeELId: number) {
        return this.http
            .post(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/type`,
                newCategory,

            ).pipe(rxjsmap(result => result));
    }

    //delete Instrument Type
    deleteInsType(Id: number, kundeELId: number, key: string) {
        let result: boolean;
        return this.http.delete(
            `${environment.BASE_URL}/${BaseServices.apiRoute(
                key
            )}/${kundeELId}/instrument/type/` + Id,
        );
    }

    //  bind model type
    getAllByModel(kundeELId: number, key: string) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/model`,
            ).pipe(rxjsmap((result: any) => result));
    }

    //  update Model Type
    updateModel(existingCategory: ModelType, key: string, kundeELId: number) {
        return this.http
            .put(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/model`,
                existingCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  adding Model Type
    createModel(newCategory: ModelType, key: string, kundeELId: number) {
        return this.http
            .post(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/instrument/model`,
                newCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  delete Model Type
    deleteModelType(Id: number, kundeELId: number, key: string) {
        let result: boolean;
        return this.http.delete(
            `${environment.BASE_URL}/${BaseServices.apiRoute(
                key
            )}/${kundeELId}/instrument/model/` + Id,
        );
    }

    //  create mp instrument
    createMPInstrument(newInst: Instrument) {
        return this.http
            .post(
                environment.BASE_URL + '/instrument/measureprotocol',
                newInst,

            ).pipe(rxjsmap(result => result));
    }

    //  create cmp instrument
    createCMPInstrument(newInst: Instrument) {
        return this.http
            .post(
                environment.BASE_URL + '/instrument/measureProtocolComplete/',
                newInst,

            ).pipe(rxjsmap(result => result));
    }

    //  update instrument
    updateInstrument(ExistingInst: Instrument) {
        return this.http
            .put(
                environment.BASE_URL + '/instrument',
                ExistingInst,

            ).pipe(rxjsmap(result => result));
    }

    // delete Instrument
    deleteInstrument(id: number) {
        return this.http
            .delete(environment.BASE_URL + '/instrument/' + id, ).pipe(rxjsmap(result => result));
    }

    //  get all power leakage
    getAllPowerLeakage(id: number) {
        return this.http
            .get(
                `${
                    environment.BASE_URL
                }/measureProtocolComplete/${id}/powerLeakage`,

            ).pipe(rxjsmap(result => result));
    }

    getPowerLeakageById(cmpId: number, id: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/powerLeakage/' +
                    id,
            ).pipe(rxjsmap(res => res));
    }

    createPowerLeakage(cmpId: number, newPL: PowerLeakage) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/powerLeakage',
                newPL,

            ).pipe(rxjsmap(result => result));
    }

    // update power leakage
    updatePowerLeakage(cmpId: number, ExistingPL: PowerLeakage) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/powerLeakage',
                ExistingPL,

            ).pipe(rxjsmap(result => result));
    }

    // delete power leakage
    deletePowerLeakage(id: number, cmpId: number) {
        return this.http
            .delete(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/powerLeakage/' +
                    id,
            ).pipe(rxjsmap(result => result));
    }

    //  get all power leakage
    getAllEarthLeakage(id: number) {
        return this.http
            .get(
                `${
                    environment.BASE_URL
                }/measureProtocolComplete/${id}/earthLeakageBreaker`,

            ).pipe(rxjsmap(result => result));
    }

    getEarthLeakageById(cmpId: number, id: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/earthLeakageBreaker/' +
                    id,
            ).pipe(rxjsmap(res => res));
    }

    createEarthLeakage(cmpId: number, newEL: EarthLeakage) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/earthLeakageBreaker',
                newEL,

            ).pipe(rxjsmap(result => result));
    }

    // update power leakage
    updateEarthLeakage(cmpId: number, ExistingEL: EarthLeakage) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/earthLeakageBreaker',
                ExistingEL,

            ).pipe(rxjsmap(result => result));
    }

    // delete power leakage
    deleteEarthLeakage(id: number, cmpId: number) {
        return this.http
            .delete(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/earthLeakageBreaker/' +
                    id,
            ).pipe(rxjsmap(result => result));
    }

    //  bind Temperature type
    getAllByTemperatureType(kundeELId: number, key: string, featureId:number) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/type/byfeature/${featureId}`,
            ).pipe(rxjsmap((result: any) => result));
    }

    //  update Temperature Type
    updateTemperatureType(
        existingCategory: TemperatureType,
        key: number,
        kundeELId: number
    ) {
        return this.http
            .put(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/type`,
                existingCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  adding Temperature Type
    createTemperatureType(
        newCategory: TemperatureType,
        key: number,
        kundeELId: number
    ) {
        return this.http
            .post(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/type`,
                newCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  delete Temperature Type
    deleteTemperatureType(Id: number, kundeELId: number, key: string, featureId: number) {
        let result: boolean;
        return this.http.delete(
            `${environment.BASE_URL}/${BaseServices.apiRoute(
                key
            )}/${kundeELId}/MPCTemperature/type/` + Id + '/'+ featureId,
        );
    }

    //  bind Temperature type
    getAllByTemperatureModel(kundeELId: number, key: string, featureId:number) {
        return this.http
            .get(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/model/byfeature/${featureId}`,
            ).pipe(rxjsmap((result: any) => result));
    }

    //  update Temperature Type
    updateTemperatureModel(
        existingCategory: TemperatureModel,
        key: number,
        kundeELId: number
    ) {
        return this.http
            .put(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/model`,
                existingCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  adding Temperature Type
    createTemperatureModel(
        newCategory: TemperatureModel,
        key: number,
        kundeELId: number
    ) {
        return this.http
            .post(
                `${environment.BASE_URL}/${BaseServices.apiRoute(
                    key
                )}/${kundeELId}/MPCTemperature/model`,
                newCategory,

            ).pipe(rxjsmap(result => result));
    }

    //  delete Temperature Type
    deleteTemperatureModel(Id: number, kundeELId: number, key: string, featureId: number) {
        let result: boolean;
        return this.http.delete(
            `${environment.BASE_URL}/${BaseServices.apiRoute(
                key
            )}/${kundeELId}/MPCTemperature/model/` + Id + '/'+ featureId,
        );
    }

    //  get all cmp temperature
    getAllCMPTemperature(cmpId: number) {
        return this.http
            .get(
                `${
                    environment.BASE_URL
                }/measureProtocolComplete/${cmpId}/MPCTemperature`,

            ).pipe(rxjsmap(result => result));
    }

    getCMPTemperatureById(cmpId: number, id: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCTemperature/' +
                    id,
            ).pipe(rxjsmap(res => res));
    }

    createCMPTemperature(cmpId: number, newTemp: Temperature) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCTemperature',
                newTemp,

            ).pipe(rxjsmap(result => result));
    }

    // update power leakage
    updateCMPTemperature(cmpId: number, ExistingTemp: Temperature) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCTemperature',
                ExistingTemp,

            ).pipe(rxjsmap(result => result));
    }

    // delete comment
    deleteCMPTemperature(id: number, cmpId: number) {
        return this.http
            .delete(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCTemperature/' +
                    id,
            ).pipe(rxjsmap(result => result));
    }

    getCMPCommentById(cmpId: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCNote',

            ).pipe(rxjsmap(res => res));
    }

    // create comment
    createCMPComment(cmpId: number, newCMPComment: CMPComment) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCNote',
                newCMPComment,

            ).pipe(rxjsmap(result => result));
    }

    // update comment
    updateCMPComment(cmpId: number, ExistingCMPComment: CMPComment) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    cmpId +
                    '/MPCNote',
                ExistingCMPComment,

            ).pipe(rxjsmap(result => result));
    }

    getVisualControl(mpCompleteId: number) {
        let result: any;
        return this.http
            .get(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    mpCompleteId +
                    '/visualControl',
            ).pipe(rxjsmap((res: any) => res));
    }

    //  create instrument
    createVisualControl(newVC: VisualControl) {
        return this.http
            .post(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    newVC.MeasureProtocolCompleteId +
                    '/visualControl',
                newVC,

            ).pipe(rxjsmap(result => result));
    }

    //  update instrument
    updateVisualControl(ExistingVC: VisualControl) {
        return this.http
            .put(
                environment.BASE_URL +
                    '/measureProtocolComplete/' +
                    ExistingVC.MeasureProtocolCompleteId +
                    '/visualControl',
                ExistingVC,

            ).pipe(rxjsmap(result => result));
    }

    reportGenerate(businessId: number, cultureInfo: string, ReportJson) {
        let dynamicType = 'application/pdf';
        let myData = { data: ReportJson };
        let url = `${environment.BASE_URL}/export-MeasureProtocolCompleteChecklist/${businessId}/${cultureInfo}`;
        return this.http
            .post(url, myData, { responseType: 'blob' })
            .pipe(rxjsmap(blob => new Blob([blob], { type: dynamicType })));
    }

    getElectroBusinessInstrumentTypes() {
        return this.http.get(environment.BASE_URL +'/instrument/gettype/electrobusiness/'
        + BaseServices.BusinessId, ).pipe(rxjsmap(result => result));
    }

    getElectroBusinessInstrumentModels() {
        return this.http.get(environment.BASE_URL +'/instrument/getmodel/electrobusiness/'
        + BaseServices.BusinessId, ).pipe(rxjsmap(result => result));
    }

    createElectroInstrument(newInst: Instrument) {
        return this.http.post(environment.BASE_URL + '/instrument/electro/create',newInst, ).pipe(rxjsmap(result => result));
    }

    updateElectroInstrument(ExistingInst: Instrument) {
        return this.http.put(environment.BASE_URL + '/instrument/electro/update',ExistingInst, ).pipe(rxjsmap(result => result));
    }

    getElectroBusinessInstruments() {
        return this.http.get(environment.BASE_URL +'/instrument/electro/getbybusiness/'
        + BaseServices.BusinessId, ).pipe(rxjsmap(result => result));
    }

    saveInstrumentsforMPCompleteElectro(CMPInstruments: CMPInstrument[]){
        return this.http.post(environment.BASE_URL +'/instrument/electro/measureprotocolComplete',
        CMPInstruments, ).pipe(rxjsmap(result => result));
    }

    getElectroCompleteMP(id:number) {
        return this.http.get(environment.BASE_URL +'/measureProtocol/'+0+'/measureProtocolComplete/electro/'
        + id, ).pipe(rxjsmap(result => result));
    }

    getElectroCompleteMPPreview(id:number) {
        return this.http.get(environment.BASE_URL +'/measureProtocol/'+0+'/measureProtocolComplete/electropreview/'
        + id, ).pipe(rxjsmap(result => result));
    }
}
